export default __webpack_public_path__ + "static/media/add.2e0ef73f.svg";